import { query } from "@core/helpers/graphql";
import { GET_FORM_DEFINITION } from "./_queries";

// variables: { id } or { key }. A form in the recycle bin, or one with no version, answers with a not-found error.
export const get_form_definition_query = async (variables, options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_FORM_DEFINITION, variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};
